<template>
  <div data-reveal class="rounded-lg border border-[var(--border)] bg-[var(--surface)] p-5 backdrop-blur-md">
    <div class="flex flex-wrap items-baseline justify-between gap-2">
      <h3 class="text-lg font-bold">{{ entry.company }}</h3>
      <p class="font-mono text-xs text-[var(--muted)]">
        {{ loc(entry.location) }} · {{ entry.period }}
      </p>
    </div>
    <div v-for="role in entry.roles" :key="role.period" class="mt-4">
      <p class="font-mono text-sm text-[var(--accent)]">
        {{ loc(role.title) }} <span class="text-[var(--muted)]">· {{ role.period }}</span>
      </p>
      <ul class="mt-2 space-y-2">
        <li
          v-for="(bullet, i) in role.bullets"
          :key="i"
          class="flex gap-2 text-sm text-[var(--muted)]"
        >
          <span class="font-mono text-[var(--accent)]" aria-hidden="true">▸</span>
          <span>{{ loc(bullet) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { loc, type ExperienceEntry } from '../data'

defineProps<{ entry: ExperienceEntry }>()
</script>
